import { render, staticRenderFns } from "./AppWrapper.vue?vue&type=template&id=08c91f0b&"
import script from "./AppWrapper.js?vue&type=script&lang=js&"
export * from "./AppWrapper.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports